module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    key: _vm.project.key,
    staticClass: "c-slider__item",
    class: _vm.slideAdditionalClasses,
    attrs: {
      "id": _vm.project.id
    }
  }, [_c('slider-item-infos', {
    attrs: {
      "project": _vm.project
    }
  }), _vm._v(" "), _c('slider-item-background', {
    attrs: {
      "tempCurrentIndex": _vm.slideCurrentIndex,
      "project": _vm.project
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2c941e12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Slider/SliderItem.vue
// module id = 88
// module chunks = 2